"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SSRCSSPlugin_exports = {};
__export(SSRCSSPlugin_exports, {
  SSRCSSPlugin: () => SSRCSSPlugin,
  collectStyle: () => collectStyle
});
module.exports = __toCommonJS(SSRCSSPlugin_exports);
var import_constants = require("../../constants");
function SSRCSSPlugin(pluginOpts) {
  var server;
  return {
    name: `one-plugin-ssr-css`,
    apply: "serve",
    configureServer(server_) {
      server = server_;
      server.middlewares.use(async function(req, res, next) {
        var _req_url;
        if ((_req_url = req.url) === null || _req_url === void 0 ? void 0 : _req_url.includes(import_constants.VIRTUAL_SSR_CSS_HREF)) {
          invalidateModule(server, "\0" + import_constants.VIRTUAL_SSR_CSS_ENTRY + "?direct");
          var code = await collectStyle(server, pluginOpts.entries);
          res.setHeader("Content-Type", "text/css");
          res.setHeader("Cache-Control", "no-store");
          res.setHeader("Vary", "*");
          res.write(code);
          res.end();
          return;
        }
        next();
      });
    },
    // virtual module
    // (use `startsWith` since Vite adds `?direct` for raw css request)
    resolveId(source, _importer, _options) {
      return source.startsWith(import_constants.VIRTUAL_SSR_CSS_ENTRY) ? "\0" + source : void 0;
    },
    async load(id, _options) {
      if (id.startsWith("\0" + import_constants.VIRTUAL_SSR_CSS_ENTRY)) {
        var url = new URL(id.slice(1), "https://test.local");
        var code = await collectStyle(server, pluginOpts.entries);
        if (!url.searchParams.has("direct")) {
          code = `export default ${JSON.stringify(code)}`;
        }
        return code;
      }
      return;
    },
    // also expose via transformIndexHtml
    transformIndexHtml: {
      handler: async function handler() {
        return [
          {
            tag: "link",
            // prepend so SSR CSS comes BEFORE individual style tags injected by JS
            // this ensures individual styles (later in DOM) win in CSS cascade
            injectTo: "head-prepend",
            attrs: {
              rel: "stylesheet",
              href: import_constants.VIRTUAL_SSR_CSS_HREF,
              "data-ssr-css": true
            }
          },
          {
            tag: "script",
            injectTo: "head",
            attrs: {
              type: "module"
            },
            children: (
              /* js */
              `
              import { createHotContext } from "/@vite/client";
              const hot = createHotContext("/__clear_ssr_css");
              hot.on("vite:beforeUpdate", () => {
                document
                  .querySelectorAll("[data-ssr-css]")
                  .forEach(node => { node.disabled = true; });
              });
            `
            )
          }
        ];
      }
    }
  };
}
function invalidateModule(server, id) {
  var mod = server.moduleGraph.getModuleById(id);
  if (mod) {
    server.moduleGraph.invalidateModule(mod);
  }
}
async function collectStyle(server, entries) {
  var { transform } = await import("lightningcss");
  var urls = await collectStyleUrls(server, entries);
  var codes = await Promise.all(urls.map(async function(url) {
    var res = await server.transformRequest(url + "?direct");
    var code = (res === null || res === void 0 ? void 0 : res.code) || "";
    var prefix = `/* [collectStyle] ${url} */`;
    try {
      var buffer2 = Buffer.from(code);
      var codeOut2 = new Uint8Array(buffer2.buffer, buffer2.byteOffset, buffer2.byteLength);
      var processed = transform({
        filename: "code.css",
        code: codeOut2,
        ...server.config.css.lightningcss
      }).code.toString();
      return [
        prefix,
        processed
      ];
    } catch (err) {
      console.error(` [one] Error post-processing CSS, leaving un-processed: ${err}`);
      return [
        prefix,
        code
      ];
    }
  }));
  var out = codes.flat().filter(Boolean).join("\n\n");
  try {
    var buffer = Buffer.from(out);
    var codeOut = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    out = transform({
      filename: "code.css",
      code: codeOut,
      ...server.config.css.lightningcss
    }).code.toString();
  } catch (err) {
    console.error(` [one] Error post-processing merged CSS, leaving un-processed`);
  }
  return out;
}
async function collectStyleUrls(server, entries) {
  var visited = /* @__PURE__ */ new Set();
  function walk(root) {
    var stack = [
      root
    ];
    while (stack.length) {
      var mod = stack.pop();
      if (!mod.id || mod.url.includes(".server.") || visited.has(mod.id)) continue;
      visited.add(mod.id);
      var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
      try {
        for (var _iterator = mod.importedModules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var childMod = _step.value;
          stack.push(childMod);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
  async function traverse(url) {
    if (url.includes(".server.")) return;
    var [, id] = await server.moduleGraph.resolveUrl(url);
    if (visited.has(id)) {
      return;
    }
    visited.add(id);
    var mod = server.moduleGraph.getModuleById(id);
    if (!mod) {
      return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = mod.importedModules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var childMod = _step.value;
        walk(childMod);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  await Promise.all(entries.map(function(e) {
    return server.transformRequest(e);
  }));
  await Promise.all(entries.map(function(url) {
    return traverse(url);
  }));
  return [
    ...visited
  ].filter(function(url) {
    return url.match(CSS_LANGS_RE);
  });
}
var CSS_LANGS_RE = /\.(css|less|sass|scss|styl|stylus|pcss|postcss|sss)(?:$|\?)/;
//# sourceMappingURL=SSRCSSPlugin.js.map
